<template>
  <div style="position: inherit; margin-top: 2">
    <v-overlay class="align-start" :opacity="1" style="z-index: 1000000" color="white">
      <v-row justify="center" no-gutters style="margin-left: 15%; margin-right: 15%; margin-top: 100px">
        <v-col cols="12" class="d-flex justify-center">
          <div class="prominent-icon-wrapper">
            <div class="prominent-icon-bg" style="background-color: gray"></div>
            <div class="prominent-icon">
              <v-icon color="#545454" size="25"> mdi-incognito-off </v-icon>
            </div>
          </div>
        </v-col>
        <v-col cols="12" class="text-center mt-3">
          <span class="font-weight-bold" style="font-size: 15px; color: #333333"> {{ $t('incognitoModeComponent.title') }} </span>
        </v-col>
        <v-col cols="12" class="text-center mt-2">
          <span class="font-weight-medium" style="font-size: 15px; color: #333333"> {{ $t('incognitoModeComponent.message') }} </span>
        </v-col>
      </v-row>
    </v-overlay>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'IncognitoModeComponent',
  computed: {
    ...mapState(['x_language'])
  },
  watch: {
    x_language: function () {
      this.$i18n.locale = this.x_language?.toLowerCase() || 'es'
    }
  }
}
</script>
